import script from "./PayeeAdminHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayeeAdminHome.vue?vue&type=script&setup=true&lang=ts"

import "./PayeeAdminHome.vue?vue&type=style&index=0&id=15acb970&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15acb970"]])

export default __exports__